export default {
  dl: "invalid_api_key",
  fl: "blacklisted",
  ml: "no_device_identifier",
  cl: "invalid_json_response",
  hl: "empty_response",
  __: "sdk_auth_error",
};
